import { StateOfRelatedObjectsController } from './state-of-related-objects.controller';
import { StateOfRelatedObjectsProps } from './state-of-related-objects.model';

export const StateOfRelatedObjects = (props: StateOfRelatedObjectsProps) => {
  return <StateOfRelatedObjectsController {...props} />;
};
